import { IClassname } from '@/lib/shared/model/classname';

export const Toaster = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14249_7702)">
        <path
          d="M3.85979 11.5273H25.5844C26.2622 11.5273 26.9123 11.7966 27.3916 12.2759C27.8709 12.7552 28.1402 13.4053 28.1402 14.0832V26.8623H1.30396V14.0832C1.30396 13.4053 1.57323 12.7552 2.05255 12.2759C2.53185 11.7966 3.18194 11.5273 3.85979 11.5273Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.30396 26.8623H28.1402V28.1402C28.1402 28.818 27.8709 29.4681 27.3916 29.9475C26.9123 30.4268 26.2622 30.6961 25.5844 30.6961H3.85979C3.18194 30.6961 2.53185 30.4268 2.05255 29.9475C1.57323 29.4681 1.30396 28.818 1.30396 28.1402V26.8623Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.1401 25.584H30.696"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.4727 1.30371H6.41563C5.94853 1.30295 5.49722 1.47277 5.14648 1.78127C4.79574 2.08977 4.56973 2.51571 4.51088 2.9791C4.45204 3.44248 4.56442 3.91141 4.82691 4.29778C5.0894 4.68416 5.48394 4.96139 5.93641 5.0774C6.07355 5.11281 6.19502 5.19277 6.28177 5.30473C6.3685 5.41669 6.41559 5.55429 6.41563 5.69591V11.527H20.4727V5.69591C20.4727 5.55429 20.5199 5.41669 20.6066 5.30473C20.6933 5.19277 20.8148 5.11281 20.9519 5.0774C21.4044 4.96139 21.7989 4.68416 22.0614 4.29778C22.3239 3.91141 22.4364 3.44248 22.3774 2.9791C22.3187 2.51571 22.0926 2.08977 21.7418 1.78127C21.3912 1.47277 20.9398 1.30295 20.4727 1.30371Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.6676 18.2366C23.4911 18.2366 23.3481 18.0936 23.3481 17.9171C23.3481 17.7407 23.4911 17.5977 23.6676 17.5977"
          stroke="#22364A"
          strokeWidth="1.33"
        />
        <path
          d="M23.6675 18.2366C23.844 18.2366 23.987 18.0936 23.987 17.9171C23.987 17.7407 23.844 17.5977 23.6675 17.5977"
          stroke="#22364A"
          strokeWidth="1.33"
        />
        <path
          d="M23.6676 22.0696C23.4911 22.0696 23.3481 21.9266 23.3481 21.7501C23.3481 21.5737 23.4911 21.4307 23.6676 21.4307"
          stroke="#22364A"
          strokeWidth="1.33"
        />
        <path
          d="M23.6677 22.0696C23.8442 22.0696 23.9872 21.9266 23.9872 21.7501C23.9872 21.5737 23.8442 21.4307 23.6677 21.4307"
          stroke="#22364A"
          strokeWidth="1.33"
        />
      </g>
      <defs>
        <clipPath id="clip0_14249_7702">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
